import { render, staticRenderFns } from "./FilterItemStatistic.vue?vue&type=template&id=296c1ceb&scoped=true&"
import script from "./FilterItemStatistic.vue?vue&type=script&lang=js&"
export * from "./FilterItemStatistic.vue?vue&type=script&lang=js&"
import style0 from "./FilterItemStatistic.vue?vue&type=style&index=0&id=296c1ceb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296c1ceb",
  null
  
)

export default component.exports